import { all_roles } from '@/utils';
import { Patchnotes } from '@/modules/patchnotes/types';

const access_roles = {
  [Patchnotes.Pages.PATCHNOTES]: all_roles,
};

export default access_roles;
